import PrintersTableReducer from "./reducers/PrintersTableReducer";
import PrintersSaga from "./saga";
import PrintPrinterSelectModal from "./modals/PrintPrinterSelectModal";

import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "print.printers";
export const url = "printers";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["print.printers.read"]) {
        config.active = true;

        store.reducerManager?.add("PrintPrinterTable", PrintersTableReducer);
        store.injectSaga?.("PrintPrintersSaga", PrintersSaga);
        registerModals({ PrintPrinterSelectModal });

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Print/Printers/pages/PrintersIndexPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
